import { IContact } from 'clickNgo/entities/contact'
import { IContactFlags } from 'clickNgo/entities/contactFlag'
import { fetchContactFlagsByIds } from 'clickNgo/entities/contactFlag/api'
import { mapIContactFlagToGroupedContactFlags } from 'clickNgo/entities/contactFlag/api/mapping'
import { getContactFlagsToReassign } from 'clickNgo/features/contact/contactReassignment/lib'
import { countriesWithoutPPAReassigningStep } from 'clickNgo/features/contact/contactRelinking/contactRelinkingValidationModal/configs'

interface IDetermineFlagsToReassign {
  contact: IContact
  availableContacts: IContact[]
  contactFlags: IContactFlags
}

export const determineFlagsToReassign = async ({
  contact,
  availableContacts,
  contactFlags,
}: IDetermineFlagsToReassign) => {
  const availableContactFlags = await fetchContactFlagsByIds(
    availableContacts.map((el) => el.contactId),
    contact.topPartnerId
  )

  const importantFlags = getContactFlagsToReassign(contactFlags)
  const availableContactsImportantFlags = getContactFlagsToReassign(
    mapIContactFlagToGroupedContactFlags(availableContactFlags)
  )

  const flagsToReassign = countriesWithoutPPAReassigningStep.includes(contact.countryOfBusiness)
    ? []
    : importantFlags.filter(
        (f) => !availableContactsImportantFlags.some((a) => a.flag.code === f.flag.code)
      )

  const isNeedReassignFlag = flagsToReassign.length > 0

  return { flagsToReassign, isNeedReassignFlag }
}
